import { network } from 'services/network';

export const getActivityCodesByContract = (contractId) => {
    return network.get(`api/bo/getActivityCodesByContract?contractId=${contractId}`).then((response) => {
        return response.data;
    });
};
